import {default_training_company, default_params} from './state';

/**
 * Establecer un valor para la variable training_companies
 */
export function setTrainingCompanies(state, training_companies) {
    state.training_companies = training_companies;
}

/**
 * Establecer un valor para la variable training_company.
 */
export function setTrainingCompany(state, training_company) {
    state.training_company = training_company;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.training_companies = {data: []};
}

/**
 * Establecer el valor por defecto de training_company.
 */
export function resetTrainingCompany(state) {
    state.training_company = default_training_company();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = {file: null};
    state.modal_upload.show = show;
}
